import * as React from "react"
import { Link, navigate } from "gatsby"
import styled from "styled-components"
//@ts-ignore
import Logo from "../../assets/logo.svg"
//@ts-ignore
import Burger from "../../assets/burger.svg"
//@ts-ignore
import SelectedBurger from "../../assets/selectedBurger.svg"
//@ts-ignore
import Search from "../../assets/search.svg"
//@ts-ignore
import SelectedSearch from "../../assets/selectedSearch.svg"
//@ts-ignore
import SearchBarSearch from "../../assets/searchBarInputSearch.svg"

import { motion } from "framer-motion"
import { TNavState } from "../Page"

const FixedNavStyles = styled.div`
  display: flex;
  position: fixed;

  top: 48px;

  left: 0;
  right: 0;

  > img.logo {
    margin-right: auto;
  }

  > img.burger {
    margin-right: 20px;
  }
`

const SideNav = styled(motion.nav)`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  padding-top: 49px;
  padding-left: 54px;
  padding-right: 46px;
  width: 350px;
  background-color: #250532;
  z-index: 60;
  a {
    text-decoration: none;
    font-weight: bold;
    font-family: "Amasis";
  }

  ul {
    list-style-type: none;
  }

  .heading {
    font-family: serif;
    font-weight: bold;
    color: #fffcf8;
    font-family: "Amasis";
    margin-bottom: 24px;

    &.parent {
      margin-bottom: 15px;
    }

    a {
      color: #fffcf8;
    }
  }

  .nested {
    padding-left: 8px;
    display: flex;
    flex-direction: column;

    li {
      margin-top: 8px;
    }
    a {
      font-family: "Tinos", serif;
      font-style: italic;
      color: #c29dc1;
      padding-top: 8px;
    }
  }
`

const NavHeader = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-end;

  img:first-child {
    margin-right: 18px;
  }
`

const InputWithIcon = styled.div`
  display: flex;

  &:focus-within {
    outline: 2px solid rgb(94, 158, 215);
  }
  > input {
    flex: 1;
    padding: 12px;
    border: 1px solid #6b3e7d;
    border-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
    background-color: #351343;
    outline: none;
    color: #fffcf8;
    font-family: Cabin, sans-serif;
  }

  > img {
    background-color: #351343;
    border: 1px solid #6b3e7d;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-left: 0;
    padding-right: 12px;
  }
`

const variants = {
  initial: { x: 350 },
  pushLeft: { x: 0 },
}

const FixedImg = styled.img`
  position: fixed;
  top: 48px;
  & {
    z-index: 100000;
  }
  &.logo {
    left: 48px;
  }
  &.burger {
    transform: translateY(20px);
    right: 105px;
  }

  &.search {
    transform: translateY(15px);
    right: 48px;
  }

  @media screen and (max-width: 470px) {
    &.hide-me {
      display: none;
    }
  }

  @media screen and (max-width: 620px) {
    top: 24px;

    &.logo {
      left: 24px;
    }
    &.burger {
      transform: translateY(20px);
      right: 81px;
    }

    &.search {
      transform: translateY(15px);
      right: 24px;
    }
  }
`

const FixedNav: React.FC<{
  toggleNav: Function
  setSearch: Function
  navState: TNavState
  navRef: React.MutableRefObject<HTMLElement>
  searchRef: React.MutableRefObject<HTMLElement>
}> = ({ toggleNav, setSearch, navState, navRef, searchRef }) => {
  const [searchQuery, setSearchQuery] = React.useState("")
  return (
    <>
      {/* <FixedNavStyles> */}
      <Link to="/">
        <FixedImg
          src={Logo}
          className={`logo tap-icons ${
            navState === "nav" || navState === "search" ? "hide-me" : "show-me"
          }`}
        />
      </Link>
      <FixedImg
        src={Burger}
        className="burger tap-icons"
        onClick={e => toggleNav()}
        style={{
          display:
            navState === "nav" || navState === "search" ? "none" : "block",
        }}
      />
      <FixedImg
        src={Search}
        className="search tap-icons"
        onClick={e => setSearch()}
        style={{
          display:
            navState === "nav" || navState === "search" ? "none" : "block",
        }}
      />
      {/* </FixedNavStyles> */}

      {/* one for normal list */}
      <SideNav
        initial={{ x: 350 }}
        variants={variants}
        animate={navState === "nav" ? "pushLeft" : "initial"}
        ref={navRef}
      >
        <NavHeader>
          <img
            src={SelectedBurger}
            onClick={e => toggleNav()}
            className="tap-icons"
          />
          <img
            src={SelectedSearch}
            className="tap-icons"
            onClick={e => setSearch()}
          />
        </NavHeader>

        <ul>
          <li className="heading">
            <Link to="/">Home</Link>
          </li>
          <li className="heading">
            <Link to="/about-us">About Us</Link>
            <ul className="nested">
              <li>
                <Link to="/recweek">Become A Heightser</Link>
              </li>
            </ul>
          </li>
          <li className="heading parent">
            Our Works
            <ul className="nested">
              <li>
                <Link to="/our-works-features">Features</Link>
              </li>
              <li>
                <Link to="/our-works-news">News</Link>
              </li>
              <li>
                <Link to="/our-works-opinions">Opinions</Link>
              </li>
              <li>
                <Link to="/our-works-reviews">Reviews</Link>
              </li>
            </ul>
          </li>
          <li className="heading parent">
            Our Events
            <ul className="nested">
              {/* <li>
                <Link to="/our-works-ahaw">AHAW &amp; AHWW</Link>
              </li> */}
              <li>
                <Link to="/folio-page">Folio Launch</Link>
              </li>
              <li>
                <a href="https://kuwentongpambata.com/" target="_blank">
                  Kuwentong Pambata
                </a>
              </li>
            </ul>
          </li>
          <li className="heading parent">
            Contribute
            <ul className="nested">
              <li>
                <Link to="/contribute">English Works</Link>
              </li>
              <li>
                <Link to="/contribute">Filipino Works</Link>
              </li>
              <li>
                <Link to="/contribute">Artworks</Link>
              </li>
            </ul>
          </li>
        </ul>
      </SideNav>
      {/* one for search*/}
      <SideNav
        initial={{ x: 350 }}
        variants={variants}
        animate={navState === "search" ? "pushLeft" : "initial"}
        ref={searchRef}
      >
        <form
          onSubmit={e => {
            e.preventDefault()
            navigate(`/search?q=${searchQuery}`)
          }}
        >
          <InputWithIcon>
            <input
              type="text"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            <img src={SearchBarSearch} alt="" />
          </InputWithIcon>
        </form>
      </SideNav>
    </>
  )
}

export default FixedNav
